import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import LogoSVG from "../../images/business-plan-workshop/shade.svg";

function aboutInstructor() {
  return (
    <>
      <section className="workshop-instructor p-100">
        <Container>
          <style>
            {`
                body .new-main-head {
                  display: none;
                }
              `}
          </style>
          <div className="workshop-ins-wrap">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1402"
              height="1402"
              fill="none"
              viewBox="0 0 1402 1402"
            >
              <g filter="url(#filter0_f_5337_3628)">
                <circle
                  cx="701"
                  cy="701"
                  r="451"
                  fill="#063A53"
                  fillOpacity="0.45"
                ></circle>
              </g>
              <defs>
                <filter
                  id="filter0_f_5337_3628"
                  width="1402"
                  height="1402"
                  x="0"
                  y="0"
                  colorInterpolationFilters="sRGB"
                  filterUnits="userSpaceOnUse"
                >
                  <feFlood
                    floodOpacity="0"
                    result="BackgroundImageFix"
                  ></feFlood>
                  <feBlend
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  ></feBlend>
                  <feGaussianBlur
                    result="effect1_foregroundBlur_5337_3628"
                    stdDeviation="125"
                  ></feGaussianBlur>
                </filter>
              </defs>
            </svg>
            <Row className="align-items-center">
              <Col xs={12} md={7} lg={7} xl={7} xxl={7}>
                <div className="content text-white">
                  <span className="sub-title">Meet Your Instructor</span>
                  <h2 className="title text-white">
                    Irfan U. Haq <br className="d-lg-block d-none" />
                    {/* <span>COO of TekRevol</span> */}
                  </h2>
                  <div className="item">
                    <div className="flex-item">
                      <div className="flex-content">
                        <h5>Chief Operating Officer</h5>
                      </div>
                      <div className="flex-img">
                        <StaticImage
                          src="../../images/business-plan-workshop/Tek-logo.webp"
                          alt="tek-logo"
                          className="img-fluid mw-100"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["auto"]}
                          width={200}
                          height={30}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="flex-item">
                      <div className="flex-content">
                        <h5>Chief Strategy Officer</h5>
                      </div>
                      <div className="flex-img">
                        <StaticImage
                          src="../../images/business-plan-workshop/Revol-logo.webp"
                          alt="tek-logo"
                          className="img-fluid mw-100"
                          layout="constrained"
                          placeholder="blurred"
                          formats={["auto"]}
                          width={212}
                          height={50}
                        />
                      </div>
                    </div>
                  </div>
                  {/* <h3 className="bottom-title">Conducted By: IRFAN UL HAQ</h3> */}
                  <p>
                    With over <strong>20 years of experience</strong> in
                    business strategy, Irfan has helped countless startups and
                    established businesses refine their plans for success. He is
                    known for his practical, hands-on approach to solving
                    business challenges and turning ideas into profitable
                    ventures.
                  </p>
                  <span className="quote">
                    Quote from <span>Irfan</span>:
                    <blockquote>
                      "A well-crafted business plan isn't just a document—it's
                      your roadmap to success."
                    </blockquote>
                  </span>
                </div>
                <Link
                  href="https://www.tekrevol.com/blogs/business-plan-workshop-registration/"
                  className="btn-pri"
                  aria-label="Upcoming Webinar"
                >
                  Learn from the Best – Register Now!
                </Link>
              </Col>
              <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
                <div className="image">
                  <StaticImage
                    src="../../images/business-plan-workshop/irfan-haq.webp"
                    alt="Irfan Ul Haq"
                    className="img-fluid mw-100"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["auto"]}
                    width={627}
                    height={1193}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
}

export default aboutInstructor;
